var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"28","height":"50","viewBox":"0 0 28 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 12C10.007 19.9935 17.955 28.0456 26.0009 36","stroke":"black","stroke-width":"2.6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M26.001 12C17.994 19.9935 10.046 28.0456 2.00004 36","stroke":"black","stroke-width":"2.6"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ca729e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Close.vue
// module id = 69
// module chunks = 0